"use strict";
/**
 * Banners
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectBannersHost = exports.selectBannersLoading = exports.selectBannerItems = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const selectBannersState = (state) => state.bannersProvider;
const getBannerItems = (state) => selectBannersState(state).items;
exports.selectBannerItems = (0, toolkit_1.createSelector)([getBannerItems], (items) => {
    const currentDate = new Date();
    return items.filter((item) => {
        if (item.activeFrom) {
            const activeFrom = new Date(item.activeFrom);
            if (activeFrom > currentDate) {
                return false;
            }
        }
        if (item.activeTo) {
            const activeTo = new Date(item.activeTo);
            if (activeTo < currentDate) {
                return false;
            }
        }
        return true;
    });
});
const selectBannersLoading = (state) => selectBannersState(state).fetchItems.loading;
exports.selectBannersLoading = selectBannersLoading;
const selectBannersHost = (state) => selectBannersState(state).host;
exports.selectBannersHost = selectBannersHost;
//# sourceMappingURL=selectors.js.map